import * as React from 'react';
import { useSelector } from 'react-redux';
import { CallbackRequestBlock } from '../../components/CallbackRequestBlock';
import { LayoutBlock } from '../../components/LayoutBlock';
import { selectMessageButtonAvailable } from '../../selectors/messageButton';
import { getAgentForCallback } from '../../selectors/newbuilding/agent';
import { CallMeBackContainer } from '../CallMeBack';

export const CallbackRequestBlockContainer = () => {
  const isMessageButtonAvailable = useSelector(selectMessageButtonAvailable);
  const agentForCallback = useSelector(getAgentForCallback);

  if (!isMessageButtonAvailable || !agentForCallback) {
    return null;
  }

  return (
    <LayoutBlock>
      <CallbackRequestBlock
        callbackButton={
          <CallMeBackContainer placeType="floating_block" buttonTheme="fill_primary" buttonText="Заказать звонок" />
        }
      />
    </LayoutBlock>
  );
};
